<script>

export default {
  props: ['items'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <table class="table table-hover m-0 _f-s-12">
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td v-tippy :content="
          `<div class='text-left _f-s-12'><strong>Paid Date: </strong>`+
          (item.paid_date ? moment(item.paid_date).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>Created Date: </strong>`+
          (item.created_at ? moment(item.created_at).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>List Date: </strong>`+
          (item.ListingContractDate ? moment(item.ListingContractDate).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>Pending Date: </strong>`+
          (item.PendingTimestamp ? moment(item.PendingTimestamp).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>Sold Date: </strong>`+
          (item.CloseDate ? moment(item.CloseDate).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>Expired Date: </strong>`+
          (item.ExpirationDate ? moment(item.ExpirationDate).format('MM-DD-YYYY') : 'N/A')+
          `<br><strong>Cancelled Date: </strong>`+
          (item.CancellationDate ? moment(item.CancellationDate).format('MM-DD-YYYY') : 'N/A')
          ">{{item.Address}}<br>{{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</td>
        <td class="_f-uppercase" v-tippy :content="
          `<div class='text-left _f-s-12'><strong>Last update from MLS: </strong>`+
          (item.mls_updated_at ? moment(item.mls_updated_at).format('MM-DD-YYYY') : 'N/A')
          ">{{item.mls_title}}<br>{{item.ListingId}}</td>
        <td>
          <div class="text-nowrap" v-tippy :content="
            `<div class='text-left _f-s-12'><strong>Package</strong><br>`+
            (item.active_package ? `<span class='text-success'>`+formatPrice(item.active_package.price)+'</span> - '+item.active_package.title : 'Unknown')+
            (item.active_services && Object.keys(item.active_services).length ?
              `<br><strong>A La Carte Services</strong>`+
              item.active_services.map(b => { return `<br><span class='text-success'>`+formatPrice(b.price)+'</span> - '+b.title; })
            : '')+
            '</div>'
            ">
            <strong :class="item.estimated_total > 0 ? 'text-success' : ''">{{formatPrice(item.estimated_total)}}</strong>
            <div>
              {{(item.active_package ? item.active_package.title : 'Unknown')}}
              + {{(item.active_services && Object.keys(item.active_services).length > 0 ? Object.keys(item.active_services).length : '0')}} Service(s)
            </div>
          </div>
        </td>
        <td>
          <div v-if="item.StandardStatus == 'Awaiting Order'" class="alert alert-warning m-0 py-1">Awaiting Order</div>
          <div v-else-if="item.StandardStatus == 'Awaiting Forms'" class="alert alert-warning m-0 py-1">Awaiting Forms</div>
          <div v-else-if="item.StandardStatus == 'Awaiting Photos'" class="alert alert-warning m-0 py-1">Awaiting Photos</div>
          <div v-else-if="item.StandardStatus == 'Awaiting Signatures'" class="alert alert-warning m-0 py-1">Awaiting Signatures</div>
          <div v-else-if="item.StandardStatus == 'Awaiting Listing'" class="alert alert-warning m-0 py-1">Awaiting Listing</div>
          <div v-else-if="item.StandardStatus == 'Coming Soon'" class="alert alert-warning m-0 py-1">Coming Soon</div>
          <div v-else-if="item.StandardStatus == 'Active'" class="alert alert-success m-0 py-1">Active</div>
          <div v-else-if="item.StandardStatus == 'Active Under Contract'" class="alert alert-info m-0 py-1">Active Under Contract</div>
          <div v-else-if="item.StandardStatus == 'Pending'" class="alert alert-info m-0 py-1">Pending</div>
          <div v-else-if="item.StandardStatus == 'Delete'" class="alert alert-info m-0 py-1">Delete</div>
          <div v-else-if="item.StandardStatus == 'Expired'" class="alert alert-info m-0 py-1">Expired</div>
          <div v-else-if="item.StandardStatus == 'Hold'" class="alert alert-info m-0 py-1">Hold</div>
          <div v-else-if="item.StandardStatus == 'Incomplete'" class="alert alert-info m-0 py-1">Incomplete</div>
          <div v-else-if="item.StandardStatus == 'Withdrawn'" class="alert alert-info m-0 py-1">Withdrawn</div>
          <div v-else-if="item.StandardStatus == 'Canceled'" class="alert alert-info m-0 py-1">Canceled</div>
          <div v-else-if="item.StandardStatus == 'Closed'" class="alert alert-info m-0 py-1">Closed</div>
          <div v-else-if="item.StandardStatus == 'Trash'" class="alert alert-danger m-0 py-1">Trash</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
